
/*
 * This is the locale that is used for editing and displaying the collection (records, lists etc)
 */
import { InjectionToken } from '@angular/core';

export const COLLECTION_LOCALE = new InjectionToken<string>('COLLECTION_LOCALE');
